import { get } from 'lodash';
import store from '../redux/store';
import { listToStr } from './misc';

export const segmentIdentifyUser = (user) => {
  // eslint-disable-next-line no-undef
  analytics.identify(user.pk, {
    firstName: user.first_name,
    lastName: user.last_name,
    user_groups: user.user_groups,
    user_groups_str: listToStr(user.user_groups),
    organizations: get(user, 'organizations', []).map(o => o.name),
    organizations_str: listToStr(get(user, 'organizations', []).map(o => o.name)),
    username: user.username,
    permissions: user.permissions,
    email: user.email,
  });
};

export const analyticsTrack = (event, params, userDetailParams = false) => {
  let extraParams = {};
  if (userDetailParams) {
    const userStore = store.getState().user;
    // Check if we have user groups and organization info
    extraParams = {
      user_groups: get(userStore, 'user_groups', null),
      organizations: get(userStore, 'organizations', []).map(o => o.name),
      user_groups_str: listToStr(get(userStore, 'user_groups', null)),
      organizations_str: listToStr(get(userStore, 'organizations', []).map(o => o.name)),
    };
  }
  // eslint-disable-next-line no-undef
  return analytics.track(event, {
    ...params,
    ...extraParams,
  });
};
